import { ROOM_SETTINGS_PAGES } from '../../../../../constants/roomSettings';

const pages = [
  ROOM_SETTINGS_PAGES.SECURITY,
  ROOM_SETTINGS_PAGES.PERMISSIONS,
  ROOM_SETTINGS_PAGES.NOTIFICATIONS,
];

export default pages;
